import { render, staticRenderFns } from "./myInSchool.vue?vue&type=template&id=79343dda&"
import script from "./myInSchool.vue?vue&type=script&lang=js&"
export * from "./myInSchool.vue?vue&type=script&lang=js&"
import style0 from "./myInSchool.vue?vue&type=style&index=0&id=79343dda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports